import { Avatar } from '@mui/material';
import { Stack } from 'components';
import dayjs from 'dayjs';
import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';

import { useFetchAvatarImage } from '../hooks/useFetchAvatarImage';
import { NoteViewContent } from '../noteView/NoteViewDisplay';
import style from './noteHistory.module.scss';

type NoteHistoryItemType = Omit<ClientProfileContentItem, 'noteHistory'>;

type Props = {
  historyItem: NoteHistoryItemType;
  sitesEnabled: boolean | undefined;
};

const NoteHistoryItem = ({ historyItem, sitesEnabled }: Props) => {
  const createdByAvatarImage = useFetchAvatarImage(historyItem?.created?.profileImageKey);
  const updatedByAvatarImage = useFetchAvatarImage(historyItem?.updated?.profileImageKey);

  return (
    <div className={style.historyItem}>
      <Stack display="flex" flexDirection="column" gap="12px" mb="20px">
        <Stack
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack display="flex" flexDirection="row" gap="8px" alignItems="center">
            <p className={style.createdBy}>Created by:</p>
            <Stack gap="4px" display="flex" flexDirection="row" alignItems="center">
              <Avatar
                sx={{
                  width: 16,
                  height: 16
                }}
                alt={historyItem?.created?.profileImageKey}
                src={createdByAvatarImage}
              >
                <span className="material-icons-outlined">person</span>
              </Avatar>
              <p className={style.authorName}>{historyItem.created?.name}</p>
            </Stack>
          </Stack>
          <p className={style.date}>{dayjs(historyItem?.created.timestamp).format('MM/DD/YYYY')}</p>
        </Stack>
        <Stack
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack display="flex" flexDirection="row" gap="8px" alignItems="center">
            <p className={style.createdBy}>Finalized by:</p>
            <Stack gap="4px" display="flex" flexDirection="row" alignItems="center">
              <Avatar
                sx={{
                  width: 16,
                  height: 16
                }}
                alt={historyItem?.updated?.profileImageKey}
                src={updatedByAvatarImage}
              >
                <span className="material-icons-outlined">person</span>
              </Avatar>
              <p className={style.authorName}>{historyItem.updated?.name}</p>
            </Stack>
          </Stack>
          <p className={style.date}>{dayjs(historyItem?.updated.timestamp).format('MM/DD/YYYY')}</p>
        </Stack>
      </Stack>
      <NoteViewContent note={historyItem} sitesEnabled={sitesEnabled} />
    </div>
  );
};

export default NoteHistoryItem;
